import React, { useState, useEffect, useRef } from 'react'
import styles from './con.module.less'
import { CloseOutline } from 'antd-mobile-icons'
import { Button, Space } from 'antd-mobile'
import intl from 'react-intl-universal'
import { useSelector, useDispatch } from 'react-redux'
import { selectConCheckItems, setConditionBar } from '../../../../store/reducers/spa'

export default function TagShowBox({  tagList, tagCallback }) {
  const [tmpTagArr, setTmpTagArr] = useState([])
  const [isExpanded, setIsExpanded] = useState(false)
  const FIXED_VISIBLE_COUNT = 2; // 固定显示2个标签

  const conCheckItems = useSelector(selectConCheckItems)
  const {  tagArr } = conCheckItems
  const dispatch = useDispatch()

  useEffect(() => {
    setTmpTagArr(tagArr)
    setIsExpanded(false)
  }, [tagArr])

  return (
    <div>
      <div className='p10'>
        <div className={styles.tagShowBox}>
          <div className='jm-flex'>
            {
              tmpTagArr.map((item, index) => {
                const shouldShow = isExpanded || index < FIXED_VISIBLE_COUNT;
                return shouldShow ? (
                  <div 
                    className={styles.tagCheckItem} 
                    key={index}
                  >
                    <div className='jm-flex-item ellips' style={{ maxWidth: '50px' }}>{item.tagName}</div>
                    <div
                      onClick={() => {
                        setTmpTagArr(pre => pre.filter(tag => tag.relateTag !== item.relateTag))
                        setIsExpanded(false)
                      }}>
                      <CloseOutline />
                    </div>
                  </div>
                ) : null
              })
            }
            {!isExpanded && tmpTagArr.length > FIXED_VISIBLE_COUNT && (
              <div 
                className={styles.tagCheckItem} 
                onClick={() => setIsExpanded(true)}
                style={{ cursor: 'pointer' }}
              >
                <div className='jm-flex-item'>+{tmpTagArr.length - FIXED_VISIBLE_COUNT}</div>
              </div>
            )}
          </div>
        </div>
      </div>
      <ul className={styles.tagList} style={{ padding: 12 }}>
        {
          tagList.map(item => (
            <li
              className={tmpTagArr.includes(item) ? styles.tagActive : ''}
              key={item.id}
              onClick={() => {
                if (tmpTagArr.includes(item)) {
                  setTmpTagArr(pre => pre.filter(tag => tag.relateTag !== item.relateTag))
                } else {
                  setTmpTagArr(pre => [...pre, item])
                }
                // console.log(tmpTagArr, '====///=====')
              }}>
              {item.tagName}
            </li>
          ))
        }
      </ul>
      <div className='m-t-sm text-center'>
        <Space style={{ '--gap': '30px' }} >
          <Button
            style={{
              padding: '5px 35px',
              color: 'var(--adm-color-primary)',
              borderColor: 'var(--adm-color-primary)'
            }}
            shape='rounded'
            onClick={() => {
              setTmpTagArr([])
            }}>{intl.get('reset').d('重置')}</Button>
          <Button
            color='primary'
            style={{ padding: '5px 35px' }}
            shape='rounded'
            onClick={() => {
              
              dispatch(setConditionBar({
                ...conCheckItems,
                tagArr: tmpTagArr
              }))
              tagCallback && tagCallback(tmpTagArr)
            }}>{intl.get('ok').d('确定')}</Button>
        </Space>
      </div>
    </div>
  )
}
